import { useHistory } from "react-router-dom";
import { DropdownButton } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";

type Props = {
  clientId: number;
  clientName: string;
};

/**
 * Row ⋯ menu for the Clients grid. Create navigates to the client wizard; link navigates to the
 * clients link-case route (shell filled in by COMP-4636).
 */
export const RowActionsMenu = ({ clientId, clientName }: Props) => {
  const history = useHistory();

  const buildParams = () => {
    const params = new URLSearchParams();
    params.set("clientId", String(clientId));
    if (clientName) params.set("clientName", clientName);
    return params;
  };

  const handleCreateCase = () => {
    history.push(`${globalEnv.complianceRoute}/create-case/client?${buildParams().toString()}`);
  };

  const handleLinkCase = () => {
    history.push(`${globalEnv.complianceRoute}/clients/link-case?${buildParams().toString()}`);
  };

  return (
    <DropdownButton
      align="right"
      usePortal
      hideIcon
      variant="muted"
      childAsIcon={{ type: "ellipsis-h" }}
      aria-label="Client actions"
      data-testid="client-row-actions"
    >
      <DropdownButton.Action
        onSelect={handleCreateCase}
        data-cy="create-client-onboarding-case"
      >
        Create client onboarding case
      </DropdownButton.Action>
      <DropdownButton.Action onSelect={handleLinkCase} data-cy="link-case-to-client">
        Link case to this client
      </DropdownButton.Action>
    </DropdownButton>
  );
};

export default RowActionsMenu;
